import React from "react";
import Header from "../../components/header";

const Courses = () => {
  return (
    <div className="screen-box">
      <div className="main-box">
        <div className="main-txt">
          <Header
            header="Courses"
            btn
            onBtnClick={() => console.log("hello")}
          />
        </div>
      </div>
    </div>
  );
};

export default Courses;
